export { default as newRelicMonitoringService } from './new-relic-monitoring-service';
